export default __webpack_public_path__ + "static/media/icon-calendar.91ba9534.svg";